import { CALL_API } from '../middleware/ApiMiddleware';

export const CREATE_FEE_PAYMENT_CUSTOM_FIELD_REQUEST = 'CREATE_FEE_PAYMENT_CUSTOM_FIELD_REQUEST';
export const CREATE_FEE_PAYMENT_CUSTOM_FIELD_FAILURE = 'CREATE_FEE_PAYMENT_CUSTOM_FIELD_FAILURE';
export const CREATE_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS = 'CREATE_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS';

export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_REQUEST = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_REQUEST';
export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_FAILURE = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_FAILURE';
export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_SUCCESS = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_SUCCESS';

export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_REQUEST = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_REQUEST';
export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_FAILURE = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_FAILURE';
export const FETCH_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS = 'FETCH_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS';

export const EDIT_FEE_PAYMENT_CUSTOM_FIELD_REQUEST = 'EDIT_FEE_PAYMENT_CUSTOM_FIELD_REQUEST';
export const EDIT_FEE_PAYMENT_CUSTOM_FIELD_FAILURE = 'EDIT_FEE_PAYMENT_CUSTOM_FIELD_FAILURE';
export const EDIT_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS = 'EDIT_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS';

export const EDIT_FEE_CUSTOM_FIELD_SEQUENCE_REQUEST = 'EDIT_FEE_CUSTOM_FIELD_SEQUENCE_REQUEST';
export const EDIT_FEE_CUSTOM_FIELD_SEQUENCE_FAILURE = 'EDIT_FEE_CUSTOM_FIELD_SEQUENCE_FAILURE';
export const EDIT_FEE_CUSTOM_FIELD_SEQUENCE_SUCCESS = 'EDIT_FEE_CUSTOM_FIELD_SEQUENCE_SUCCESS';

export const EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_REQUEST = 'EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_REQUEST';
export const EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_FAILURE = 'EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_FAILURE';
export const EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_SUCCESS = 'EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_SUCCESS';

const baseURL = 'xerce/config/fee-payment-custom-fields';

export const fetchFeePaymentCustomFields = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_REQUEST,
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_SUCCESS,
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_FAILURE,
    ],
  },
});

export const createFeePaymentCustomField = (createFeeCustomFieldRequest: IConfigFeePaymentCustomFieldRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: createFeeCustomFieldRequest,
    authenticated: true,
    types: [
      CREATE_FEE_PAYMENT_CUSTOM_FIELD_REQUEST,
      CREATE_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS,
      CREATE_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
    ],
  },
});

export const fetchFeePaymentCustomField = (customFieldId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${customFieldId}`,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_REQUEST,
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS,
      FETCH_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
    ],
  },
});

export const editFeePaymentCustomField = (
  customFieldId: number,
  customFieldRequest: IConfigFeePaymentCustomFieldRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${customFieldId}`,
    method: 'put',
    body: customFieldRequest,
    authenticated: true,
    types: [
      EDIT_FEE_PAYMENT_CUSTOM_FIELD_REQUEST,
      EDIT_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS,
      EDIT_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
    ],
  },
});

export const editFeePaymentCustomFieldSequence = (sequence: number[], feePaymentFieldType: FeePaymentFieldType) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    params: { feePaymentFieldType },
    types:
      feePaymentFieldType === FeePaymentFieldType.FEE
        ? [
            EDIT_FEE_CUSTOM_FIELD_SEQUENCE_REQUEST,
            EDIT_FEE_CUSTOM_FIELD_SEQUENCE_SUCCESS,
            EDIT_FEE_CUSTOM_FIELD_SEQUENCE_FAILURE,
          ]
        : [
            EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_REQUEST,
            EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_SUCCESS,
            EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_FAILURE,
          ],
  },
});
